import Vue from 'vue';
import { RegistrableInject } from './registerable';

export default Vue.extend({
  name: 'form-component',
  mixins: [RegistrableInject('form')],
  props: {
    value: String,
    label: String,
    required: Boolean,
    rules: []
  },
  data: function() {
    return {
      visited: false,
      errors: [],
      initialValue: ''
    };
  },
  methods: {
    resetValidation: function() {
      this.errors = [];
      this.visited = false;
      this.initialValue = this.value;
    },
    validate: function(forced = false) {
      if (!this.visited && !forced) {
        return false;
      }

      // Dont validate if not required or no validation rules
      if (!this.rules && !this.required) {
        return true;
      }

      // If label excist wrap it with a '
      this.errors = [];
      let errors: string[] = this.errors as string[];
      let rules = this.rules as { check: RegExp; error: string }[];
      if (rules && rules.length) {
        for (let rule of rules) {
          if (!rule.check.test(this.value)) {
            errors.push(rule.error);
          }
        }
      }

      if (this.required && !this.value) {
        const messagePrefix = this.label ? `Veld '${this.label}'` : 'Dit veld';
        errors.push(`${messagePrefix} is verplicht.`);
      }

      return !this.errors.length;
    }
  },
  watch: {
    visited: function() {
      this.validate();
    },
    value: function() {
      this.validate();
    }
  },
  created: function() {
    // Set the initial value for dirty checking
    this.initialValue = this.value;

    // Register field so we can use them in the form component
    const me = this as any;
    me.form && me.form.register(this);
  },
  beforeDestroy: function() {
    const me = this as any;
    me.form && me.form.unregister(this);
  }
});
